module.exports = "p {\n  color: #ffffff;\n}\n\n.homepage-first-section .bigtext {\n  font-size: 24pt;\n  font-weight: bold;\n  margin-top: 4em;\n  margin-bottom: 4em;\n  font-family: \"Montserrat\";\n  color: rgb(255, 255, 255);\n  line-height: 1.2;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/payment-integration/payment-integration.component.css
// module id = ./src/app/components/payment-integration/payment-integration.component.css
// module chunks = main